import { forwardRef, type ReactNode, useImperativeHandle, useRef } from 'react';
import styled from 'styled-components';
import { ASSET_WIDTH } from '../Thumbnail/DraggingThumbnail';

type TrailerProps = {
  coords: PointerCoords;
  index: number;
  children: ReactNode;
};

export type TrailerRef = {
  setTransform: (coords: PointerCoords) => void;
  getTransform: () => PointerCoords;
};

export const Trailer = forwardRef<TrailerRef, TrailerProps>(
  ({ index, children, coords }, forwardedRef) => {
    const ref = useRef<HTMLDivElement>(null);
    const transform = useRef<PointerCoords>(coords);

    useImperativeHandle(forwardedRef, () => ({
      getTransform: () => [transform.current[0], transform.current[1]],
      setTransform: (newCoords: PointerCoords) => {
        if (!ref.current) {
          return;
        }
        const style = ref.current?.style;
        if (style) {
          style.transform = `translate(${newCoords[0]}px, ${newCoords[1]}px)`;
        }
        transform.current = newCoords;
      },
    }));

    return (
      <TrailerContainer
        ref={ref}
        style={{
          width: ASSET_WIDTH,
          height: ASSET_WIDTH,
          top: index * CARD_POSITION_STAGGER,
          left: index * CARD_POSITION_STAGGER,
          zIndex: -index,
        }}
      >
        {children}
      </TrailerContainer>
    );
  }
);

export type PointerCoords = readonly [x: number, y: number];

export const SMOOTHING_COEFF = -0.015;
const CARD_POSITION_STAGGER = 10;

const TrailerContainer = styled.div`
  position: absolute;
`;
